export default __webpack_public_path__ + "static/media/views1.a76c2b71.png";